/**
 * Custom hook for extracting metadata from assets
 * Results are memoized to avoid unnecessary recalculations
 */

import { useMemo } from 'react';
import { IAsset } from '../providers';

export interface AssetMetadata {
  hasAnimated: boolean;
}

/**
 * Hook that extracts metadata (animated status) from a list of assets
 * Results are memoized to prevent recalculation unless assets actually change
 *
 * @param assets - Array of assets to extract metadata from
 * @returns Object containing hasAnimated boolean
 */
export function useAssetMetadata(assets: IAsset[]): AssetMetadata {
  return useMemo(() => {
    const hasAnimated = assets.some((asset) => {
      const metadata = (asset as any).getMetadata?.();
      const hasAnimations = metadata.animations && Array.isArray(metadata.animations) && metadata.animations.length > 0;
      return hasAnimations;
    });

    return { hasAnimated };
  }, [assets]);
}
